import { fetchApi } from 'api/fetchApi'
import { paths } from 'api/generated/location'
import { NodeHeaders } from 'api/NodeHeaders'

export const fetchCurrentLocationApi = (headers?: NodeHeaders) => {
  return fetchApi<
    paths['/location/current']['get']['responses']['200']['schema']
  >('/location/current', { headers })
}
